import * as actionTypes from './actionTypes';

const initialState = {
  ids: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DOCUMENTS:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.RESTORE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ids: state.ids.length > 0
          ? state.ids.filter((id) => !action.ids.includes(id))
          : [],
      };
    default:
      return state;
  }
};
